export default {
    login: {
        userName: "Nome utente",
        password: "Password",
        login: "ACCEDI",
    },
    navbar: {
        home: "Principale",
        contracts: "Contratti",
        settings: "Impostazioni",
        info: "Guida",
    },
    header: {
        home: "PRINCIPALE",
        contracts: "CONTRATTI",
        settings: "IMPOSTAZIONI",
        info: "GUIDA",
        contract: "CONTRATTO",
        addService: "AGGIUNGI SERVIZIO",
        service: "SERVIZIO",
    },
    home: {
        hello: "Ciao"
    },
    contracts: {
        active: "Attivi",
        suspended: "Sospesi",
        services: "Servizi",
        noSuspendedContracts: "Non ci sono contratti sospesi",
        noServices: "Non ci sono servizi associati in sospeso in questo contratto",
        noPressupost: "Non ci sono pagamenti in sospeso in questo contratto",
        renovar: "Rinnovare il contratto"
    },
    settings: {
        user: "UTENTE",
        closeSession: "Chiudi Sessione",
        settings: "IMPOSTAZIONI",
        appLanguage: "Lingua dell'app",
        confirmationText: "Sei sicuro di voler uscire dalla tua sessione?"
    },
    info: {

    },
    addService: {
        addTitle: "Richiedi un Servizio",
        editTitle: "Servizio",
        entrance: "Entrata al campeggio",
        exit: "Uscita dal campeggio",
		pickupAtParking: "Ritirare la roulotte al parcheggio",
		deliveryAtParking: "Consegnare la roulotte al parcheggio",
        doneText: "Fatto",
        cancelText: "Annulla",
        transportDate: "Data del trasporto",
        camping: "Campeggio",
        selectCamping: "-- Seleziona --",
        parcel: "Parcella",
        selectParcel: "Indica la parcella",
        save: "Salva",
		payment: "Pagamento",
		paymentTitle: "Pagamento del servizio",
		servicePaymentConfirm: "Sei sicuro di voler procedere con il pagamento di questo servizio?",
        toastMessage: "Devi compilare tutti i campi per salvare!",

        requestService: "Richiedi questo servizio",
        serviceSummary: "Sommario del servizio",
        total: "Totale",
		paidService: "Servizio pagato",
        transactionCompleted: "Transazione completata correttamente",
        serviceConfirm: "Sei sicuro di voler richiedere questo servizio?",
        loading: "Richiesta di servizio...",

        reserveNum: "Numero di prenotazione",
        selectReserveNum: "Indica il numero",
        availableHoursInfo: "Orario disponibile per il trasporto: dalle {start} alle {end}.",

        toastMessage2: "Per richiedere un servizio entro le prossime 48 ore, contattaci."
    },
    service: {
        pending: "In Sospeso",
        completed: "Completato",
        requestCompleted: "Il servizio è stato richiesto correttamente"
    },
    contract: {
        entrance: "Entrata",
        exit: "Uscita",
        registration: "Registrazione",
        initialDate: "Data iniziale",
        finalDate: "Data finale",
        zone: "Zona",
        parkType: "Tipo di parcheggio",
        pendingServices: "Servizi in Sospeso",
        completedServices: "Servizi completati",
        pendingPressupost: "Pagamenti in sospeso",
        pendingPressupostS: "Pagamento in sospeso",
        pay: "Pagare",
        acceptConditions: "Accettare i termini e le condizioni",
        acceptConditionsTitle: "Termini e condizioni",
        contractNumberRequired: "È necessario indicare il numero di prenotazione per poter garantire il trasporto"
    },
    interceptors : {
        noAuthorized: "Utente non autorizzato"
    },
    payment: {
        confirmed: "Pagamento confermato",
        confirmedExtended: "Il pagamento è stato effettuato con successo",
        article: "Articolo",
        price: "Totale",
        informEmail: "Riceverai un'email con i dettagli del pagamento",
        goBack: "Torna indietro",
        denied: "Pagamento negato",
        deniedExtended: "C'è stato un problema con il pagamento",
        deniedInfo: "Riprova tra qualche minuto e, se il problema persiste, contattaci"
    }
};